import React, { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import SupportContent from "../../components/support/SupportContent";
import { InputCustom } from "../../components/UIElements/input-ui";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../../components/notification";
import { apiGetSupports, apiGetSupportsStats } from "../../api/support";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";

const Support = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const { showNotification } = useNotificationService();
  const [support_list, setSupport_list] = useState([]);
  const [refresh, setRefresh] = useState(false);

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );
  const [stats, setStats] = useState({
    pendingIssues: 0,
    resolvedIssues: 0,
    totalIssues: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // First call stats
        await statsRequest.mutateAsync();
        // Then call jobs
        await mutation.mutateAsync();
      } catch (error) {
        console.error("Error in sequential calls:", error);
      }
    };
    fetchData();
  }, [pagination_state?.page, refresh]);
  const handleRefresh = () => setRefresh(!refresh);
  const mutation = useMutation({
    mutationFn: () => apiGetSupports(),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (!!data?.data?.meta) {
          setPagination_state({
            hasNextPage: data?.data?.meta?.hasNextPage,
            hasPrevPage: data?.data?.meta?.hasPrevPage,
            nextPage: data?.data?.meta?.nextPage,
            page: data?.data?.meta?.page,
            pages: data?.data?.meta?.pages,
            prevPage: data?.data?.meta?.prevPage,
            reads: data?.data?.meta?.reads,
            totalDocs: data?.data?.meta?.totalDocs,
            unReads: data?.data?.meta?.unReads,
          });
        }
        if (data?.data?.data?.length > 0) {
          setSupport_list(data.data.data);
        } else {
          setSupport_list([]);
        }
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
      showNotification("Fetch process failed", "error");
    },
  });
  const statsRequest = useMutation({
    mutationFn: () => apiGetSupportsStats(),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        // Handle stats data here

        setStats(data?.data?.data);
      }
    },
    onError: (error) => {
      showNotification("Stats fetch failed", "error");
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Support and Help
            </Typography>
          </Stack>
        </Box>
      </Header>

      <SupportContent
        handleRefresh={handleRefresh}
        stats={stats}
        supportList={support_list}
        loading={mutation.isPending}
        paginationState={pagination_state}
        setPaginationState={setPagination_state}
      />
    </>
  );
};

export default Support;
